export default __webpack_public_path__ + "static/media/clock.b536d94a.gif";